import { createApp } from 'vue'
import PrivacyPolicy from './PrivacyPolicy.vue'
import './assets/global.css'

createApp(PrivacyPolicy).mount('#privacy-policy')
